import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  ${({ sidebarType }) => sidebarType === 'horizontal' ? 'flex-direction:column; align-items: center;' : ''};
`
